// Third-party imports
import 'parsleyjs';

// Local imports
import { PRODUCT as SGPRODUCT_DATALAYER } from '../../datalayer/data/product.js';
import * as event from '../../datalayer/event.js';

// Product is an object that contains the following attributes:
// * id
// * name
// * category_name
// * sku
// * variants
// * quantity
// * vendor
// * global_category
export function update_sgproduct_datalayer(product, position, listname) {
    // Tealium Data Layer for impression on donation products.
    SGPRODUCT_DATALAYER.category.push(product.category_name);
    SGPRODUCT_DATALAYER.id.push(product.id);
    SGPRODUCT_DATALAYER.name.push(product.name);
    SGPRODUCT_DATALAYER.variant.push(product.variants);
    SGPRODUCT_DATALAYER.sku.push(product.sku);
    SGPRODUCT_DATALAYER.list_position.push(position);
    SGPRODUCT_DATALAYER.list_name.push(listname);

    // These are not added to utag_data
    SGPRODUCT_DATALAYER.vendor.push(product.vendor);
    SGPRODUCT_DATALAYER.quantity.push(product.quantity);
}

// This assumes both window.utag_data and window.Parsley exists
//
// Product is an object that contains the following attributes:
// * id
// * name
// * category_name
// * sku
// * variants
// * quantity
// * vendor
// * global_category
export function update_sgproduct_validate_datalayer(
    global,
    product,
    product_first_id
) {
    let utag_data = global.utag_data;
    let data = {
        id: product_first_id,
        name: product.name,
        variant: product_first_id,
        category: product.global_category,
    };

    global.Parsley.on('form:error', () => {
        validate_bad(global, utag_data, data);
    });

    global.Parsley.on('form:success', () => {
        validate_good(global, utag_data, data);
    });
}

export function get_product_brand(global) {
    let frequency_radios = global.document.getElementById(
        'donateForm-frequency-radios'
    );
    let frequency_radio_inputs = frequency_radios.querySelectorAll(
        '.radioInput-radio'
    );
    let checkedInput = null;
    for (let input of frequency_radio_inputs) {
        if (input.checked) {
            checkedInput = input;
            break;
        }
    }

    let selected_value = checkedInput.value.toLowerCase();
    // NOTE: This sends 'NONE' to the data layer, if the product has RH as it's monthly type
    let val = 'NONE';
    if (selected_value === 'sg') {
        val = 'One Time Donation';
    } else {
        val = 'Pledge';
    }
    return val;
}

function click_give_now(global, utag_data, product) {
    let amount = global.document
        .querySelector('.donationAmount')
        .getAttribute('value');
    let product_price = amount ? undefined : 0;
    utag_data['product_price'] = product_price;
    utag_data['product_id'] = product.id;
    utag_data['product_name'] = product.name;
    utag_data['product_brand'] = get_product_brand(global);
    utag_data['product_variant'] = product.variant;
    utag_data['product_category'] = product.category;
    utag_data['product_quantity'] = '1';
}

function validate_good(global, utag_data, product, product_first_id) {
    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Add to Cart';
    utag_data['event_label'] = ' Donation Form Give Now - Success ';
    click_give_now(global, utag_data, product, product_first_id);
}

function validate_bad(global, utag_data, product) {
    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Add to Cart - Errors';
    utag_data['event_label'] = 'Donation Form Give Now - Error';
    click_give_now(global, utag_data, product);

    event.dispatch(global, event.EventKind.AddToCartError);
}

// This assumes window.utag_data exists
export function click_more_ways_to_give(global) {
    let utag_data = global.utag_data;

    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Promo Click';
    utag_data['event_label'] = 'Donation Product Detail Promo';

    utag_data['promo_ids'] = '';
    utag_data['promo_names'] = 'Donation Product Detail Promo';
    utag_data['promo_creatives'] = '';
    utag_data['promo_positions'] = '1';

    event.dispatch(global, event.EventKind.PromoClick);
}
